// extracted by mini-css-extract-plugin
module.exports = {"blue":"#3E5FA9","lightBlue":"#7e97cf","lightGrey":"#EBEFF6","orange":"#D39E36","white":"#FFFFFF","mobileDesignBreakpoint":"950px"};